import { render, staticRenderFns } from "./ProjectUsersEdit.vue?vue&type=template&id=0584de71&"
import script from "./ProjectUsersEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectUsersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports